import { theme, themeBoxShadow } from '@config/theme';
import { Tooltip, tooltipClasses } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useState } from 'react';

const CustomTooltip = styled(({ className, ...props }) => {
	const [open, setOpen] = useState(false);

	const handleTooltipOpen = () => {
		setOpen(true);
	};

	const handleTooltipClose = () => {
		setOpen(false);
	};

	return (
		<Tooltip
			{...props}
			classes={{ popper: className }}
			arrow
			open={open}
			onClose={handleTooltipClose}
			onClick={handleTooltipOpen}
			onMouseEnter={handleTooltipOpen}
			onMouseLeave={handleTooltipClose}
		>
			{props.children}
		</Tooltip>
	);
})(({ marginLeftArrow }) => ({
	[`& .${tooltipClasses.tooltip}`]: {
		borderRadius: '8px',
		border: `2px solid ${theme.palette.custom.contrastTextWhite}`,
		color: theme.palette.custom.blue,
		fontSize: '16px',
		fontStyle: 'normal',
		fontWeight: 400,
		backgroundColor: theme.palette.custom.contrastTextWhite,
		boxShadow: themeBoxShadow.secondary,
		padding: '20px',
		maxWidth: '589px',
		display: 'flex',
		gap: '10px',
	},
	[`& .${tooltipClasses.arrow}`]: {
		color: theme.palette.custom.contrastTextWhite,
		'@media (max-width: 1400px)': {
			...(marginLeftArrow ? { marginLeft: '-10px' } : { marginLeft: 0 }),
		},
		'@media (max-width: 576px)': {
			...(marginLeftArrow ? { marginLeft: '-14px' } : { marginLeft: 0 }),
		},
	},
}));

export default CustomTooltip;
